import Vue from "vue";
import Vuex from "vuex";
import BookingActionTypes from "./bookingType";
import moment from "moment";
import mystaysAPI from "@/service/mystaysAPI";
import axios from "axios";
import axiosConfig from "@/service/axiosConfig";
import { getTriplaLang } from "../utils/functions";
Vue.use(Vuex);

const calendar = localStorage.getItem("calendar");
const roomList = localStorage.getItem("roomList");
const promoCode = localStorage.getItem("promoCode");

const roomListInitial = [
  {
    id: "",
    adults: {
      title: "Adults",
      number: 2,
    },
    children: {
      title: "Children",
      childrenList: [],
    },
  },
];

const checkinDate = moment()
  .day(7)
  .format("YYYY-MM-DD");
const checkoutDate = moment()
  .day(8)
  .format("YYYY-MM-DD");

export default new Vuex.Store({
  state: {
    bookingState: {
      hotelDropdown: false,
      checking: false,
      roomSelect: false,
      promoCode: false,
      searchButton: false,
    },
    bookingData: {
      checkIn: calendar ? JSON.parse(calendar).checkIn : checkinDate,
      checkOut: calendar ? JSON.parse(calendar).checkOut : checkoutDate,
      checkOutBeforeBookingUseDay: null,
      roomList: roomList ? JSON.parse(roomList) : roomListInitial,
      promoCode: promoCode ? JSON.parse(promoCode) : "",
      promoCodeExist: {},
      searchType: "",
    },
    roomList: roomList ? JSON.parse(roomList) : roomListInitial,
    isMobile: false,
    tiers: {},
    isTiersSupport: false,
    disableBedOption: false,
    lang: "en",
    client_session: "",
    disabled_dates: [],
    inventory: {},
    currentRoomActive: 0,
    isCalendarLoading: false,
    inventoryList: [],
  },
  actions: {
    showLocation({ commit }) {
      commit(BookingActionTypes.SHOW_LOCATION);
    },
    showChecking({ commit }) {
      commit(BookingActionTypes.SHOW_CHECKING);
    },
    showRoomSelect({ commit }) {
      commit(BookingActionTypes.SHOW_ROOM_SELECT);
    },
    showPromoCode({ commit }) {
      commit(BookingActionTypes.SHOW_PROMO_CODE);
    },
    showHotelDropdown({ commit }) {
      commit(BookingActionTypes.SHOW_HOTEL_DROPDOWN);
    },
    showTotalGuest({ commit }) {
      commit(BookingActionTypes.SHOW_TOTAL_GUEST);
    },

    savePromoCode({ commit }, promoCode) {
      commit(BookingActionTypes.SAVE_PROMO_CODE, promoCode);
    },

    closeAll({ commit }) {
      commit(BookingActionTypes.CLOSE_ALL);
    },

    a_saveRoomList({ commit }, payload) {
      commit(BookingActionTypes.SAVE_ROOM_LIST, payload);
    },

    a_addRoom({ commit }) {
      commit(BookingActionTypes.ADD_ROOM);
    },

    a_deleteRoom({ commit }, roomID) {
      commit(BookingActionTypes.DELETE_ROOM, roomID);
    },

    a_onChildChange({ commit }, payload) {
      commit(BookingActionTypes.ON_CHANGE_CHILD, payload);
    },

    a_onPersonChange({ commit }, payload) {
      commit(BookingActionTypes.ON_CHANGE_PERSON, payload);
    },

    a_onChildChangeAge({ commit }, payload) {
      commit(BookingActionTypes.ON_CHANGE_CHILD_AGE, payload);
    },

    a_onChangeBedSelect({ commit }, payload) {
      commit(BookingActionTypes.ON_CHANGE_BED_SELECT, payload);
    },

    getInitialBooking({ commit }, payload) {
      commit(BookingActionTypes.GET_INITIAL_BOOKING, payload);
    },

    setInitialBooking({ commit }, payload) {
      commit(BookingActionTypes.SET_INITIAL_BOOKING, payload);
    },

    getDeviceInfo({ commit }, payload) {
      commit(BookingActionTypes.GET_DEVICE_INFO, payload);
    },

    saveTiers({ commit }, payload) {
      commit(BookingActionTypes.SAVE_TIERS_STATUS, payload);
    },

    getTiers({ commit }, hotelID) {
      mystaysAPI
        .getTiers(hotelID)
        .then((res) => {
          commit(BookingActionTypes.GET_TIERS_SUCCESS, res.data.data);
        })
        .catch((err) => commit(BookingActionTypes.GET_TIERS_FAIL, err));
    },

    getClientSession({ commit }, { key, secret }) {
      return mystaysAPI
        .getClientSession({
          key,
          secret,
        })
        .then((res) => {
          commit(
            BookingActionTypes.GET_CLIENT_SESSION_SUCCESS,
            res.data.data.client_session
          );
        })
        .catch((err) =>
          commit(BookingActionTypes.GET_CLIENT_SESSION_FAIL, err)
        );
    },

    saveCurrentRoomActive({ commit }, roomActive) {
      commit(BookingActionTypes.SAVE_CURRENT_ROOM_ACTIVE, roomActive);
    },

    getInventory({ commit }, payload) {
      const { year, month, roomList } = payload;
      let result = [];
      commit(BookingActionTypes.GET_INVENTORY);

      roomList.forEach((room) => {
        payload.q.adults = room.adults.number;
        payload.q.children = room.children.childrenList.length;
        for (let item = 0; item < 2; item++) {
          if (month < 12) {
            payload.q.checkin_date = moment(
              new Date(year, month + item, 1)
            ).format("YYYY-MM-DD");
            payload.q.checkout_date = moment(
              new Date(year, month + item + 1, 0)
            ).format("YYYY-MM-DD");
            result.push(mystaysAPI.getInventory(payload));
          } else {
            payload.q.checkin_date = new Date(year + 1, month + item, 1);
            payload.q.checkout_date = new Date(year, month + item + 1, 0);
            result.push(mystaysAPI.getInventory(payload));
          }
        }
      });

      Promise.all(result).then((res) => {
        commit(BookingActionTypes.GET_INVENTORY_SUCCESS, res);
      });
    },

    handleGetInventorySuccess({ commit }, payload) {
      commit(BookingActionTypes.GET_INVENTORY_SUCCESS, payload);
    },
  },
  mutations: {
    [BookingActionTypes.SHOW_ROOM_SELECT](state) {
      state.bookingState = {
        checking: false,
        roomSelect: true,
        promoCode: false,
        searchButton: false,
        hotelDropdown: false,
      };
    },

    [BookingActionTypes.SHOW_PROMO_CODE](state) {
      state.bookingState = {
        checking: false,
        roomSelect: false,
        promoCode: true,
        searchButton: false,
        hotelDropdown: false,
      };
    },

    [BookingActionTypes.SHOW_CHECKING](state) {
      state.bookingState = {
        checking: true,
        roomSelect: false,
        promoCode: false,
        searchButton: false,
        hotelDropdown: false,
      };
    },

    [BookingActionTypes.SHOW_HOTEL_DROPDOWN](state) {
      state.bookingState = {
        checking: false,
        roomSelect: false,
        promoCode: false,
        searchButton: false,
        hotelDropdown: true,
      };
    },

    [BookingActionTypes.CLOSE_ALL](state) {
      state.bookingState = {
        checking: false,
        roomSelect: false,
        promoCode: false,
        searchButton: false,
        hotelDropdown: false,
      };
    },
    [BookingActionTypes.DELETE_ROOM](state, roomID) {
      if (state.roomList.length > 1) {
        state.roomList.splice(roomID, 1);
      }
    },

    [BookingActionTypes.ON_CHANGE_CHILD](state, payload) {
      const { roomList } = state;
      if (payload.child.isMinus) {
        state.roomList[0].children.childrenList.pop();

        const firstRoom = { ...state.roomList[0] };
        state.roomList = roomList.map((room) => {
          return firstRoom;
        });
      } else {
        state.roomList[0].children.childrenList.push({
          title: `Child ${payload.child.data.number}`,
          age: 0,
          value: "Select Tier",
          bed: false,
        });
        const firstRoom = { ...state.roomList[0] };
        state.roomList = roomList.map((room) => {
          return firstRoom;
        });
      }
    },

    [BookingActionTypes.ON_CHANGE_PERSON](state, payload) {
      // state.roomList[payload.roomIndx].adults = payload.person.data;
      state.roomList.map((room) => {
        room.adults = payload.person.data;
        return room;
      });
    },

    [BookingActionTypes.ON_CHANGE_CHILD_AGE](state, payload) {
      // state.roomList[payload.roomIdx].children.childrenList[
      //   payload.data.index
      // ].age = payload.data.age;
      // state.roomList[payload.roomIdx].children.childrenList[
      //   payload.data.index
      // ].value = payload.data.age;

      state.roomList.map((room) => {
        room.children.childrenList[payload.data.index].age = payload.data.age;

        room.children.childrenList[payload.data.index].value = payload.data.age;

        return room;
      });
    },

    [BookingActionTypes.ON_CHANGE_BED_SELECT](state, payload) {
      // state.roomList[payload.roomIdx].children.childrenList[
      //   payload.data.index
      // ].bed = payload.data.bed;

      const { roomList } = state;
      state.roomList = roomList.map((room) => {
        room.children.childrenList[payload.data.index].bed = payload.data.bed;

        return room;
      });
    },

    [BookingActionTypes.ADD_ROOM](state) {
      // const roomModel = {
      //   id: "",
      //   adults: {
      //     title: "Adults",
      //     number: 2
      //   },
      //   children: {
      //     title: "Children",
      //     childrenList: []
      //   }
      // };
      // const roomItem = state.isTiersSupport ? { ...state.roomList[0] } : roomModel
      const roomItem = { ...JSON.parse(JSON.stringify(state.roomList[0])) };
      state.roomList.push(roomItem);
    },
    [BookingActionTypes.SAVE_ROOM_LIST](state, payload) {
      state.roomList = payload;
      const roomList = JSON.stringify(payload);
      localStorage.setItem("roomList", roomList);
    },

    [BookingActionTypes.SET_INITIAL_BOOKING](state, action) {
      const bookingDate = JSON.parse(localStorage.getItem("calendar"));
      if (!bookingDate) {
        localStorage.setItem("calendar", JSON.stringify(action));
      } else {
        let newData = {
          ...bookingDate,
          ...action,
        };

        localStorage.setItem("calendar", JSON.stringify(newData));
      }
    },

    [BookingActionTypes.GET_INITIAL_BOOKING](state) {
      const calendar = localStorage.getItem("calendar");
      const calendarInitial = {
        checkIn: checkinDate,
        checkOut: checkoutDate,
      };
      const calendarData = calendar ? JSON.parse(calendar) : calendarInitial;
      state.bookingData = {
        ...state.bookingData,
        checkIn: calendarData.checkIn,
        checkOut: calendarData.checkOut,
        checkOutBeforeBookingUseDay: calendarData.checkOut,
      };
    },

    [BookingActionTypes.GET_DEVICE_INFO](state, payload) {
      state.isMobile = payload;
    },

    [BookingActionTypes.SAVE_PROMO_CODE](state, payload) {
      if (payload !== undefined) {
        state.bookingData.promoCode = payload;
      } else if (payload === undefined && state.bookingData.promoCode) {
      } else {
        state.bookingData.promoCode = "";
      }

      localStorage.setItem(
        "promoCode",
        JSON.stringify(state.bookingData.promoCode)
      );
    },

    [BookingActionTypes.SAVE_TIERS_STATUS](state, payload) {
      state.isTiersSupport = payload.tiers;
      state.lang = payload.lang;
      state.disableBedOption = payload.disableBedOption === true;
    },

    [BookingActionTypes.GET_TIERS_SUCCESS](state, payload) {
      state.tiers = payload;
      state.isTiersSupport = payload.kids_setting.kids_type.includes("tiers");
    },

    [BookingActionTypes.GET_TIERS_FAIL]() {},

    [BookingActionTypes.GET_CLIENT_SESSION_SUCCESS](state, payload) {
      state.client_session = payload;
      axios.defaults.headers = {
        ...axiosConfig,
        "Client-Session": payload,
        "Tripla-Locale": getTriplaLang(state.lang),
      };
      localStorage.setItem("client_session", payload);
    },

    [BookingActionTypes.GET_CLIENT_SESSION_FAIL]() {
      state.client_session = null;
      localStorage.setItem("client_session", null);
      axios.defaults.headers = {
        ...axiosConfig,
        "Client-Session": null,
        "Tripla-Locale": getTriplaLang(state.lang),
      };
    },

    [BookingActionTypes.GET_INVENTORY](state) {
      state.isCalendarLoading = true;
    },

    [BookingActionTypes.GET_INVENTORY_SUCCESS](state, payload) {
      state.inventoryList = payload;
      state.inventory = payload[state.currentRoomActive].inventory;
      state.disabled_dates = payload[state.currentRoomActive].disabled_dates;
      state.isCalendarLoading = false;
    },

    [BookingActionTypes.GET_INVENTORY_FAIL](state) {
      state.isCalendarLoading = false;
    },

    [BookingActionTypes.SAVE_CURRENT_ROOM_ACTIVE](state, payload) {
      state.currentRoomActive = payload;
    },
  },
  getters: {
    kidTiers(state) {
      return state.tiers.kids_tiers;
    },

    numberAdults(state) {
      const roomList = state.roomList;
      const totalAdults = roomList
        .map((room) => room.adults.number)
        .reduce((a, b) => a + b);
      return totalAdults;
    },

    numberChildren(state) {
      const roomList = state.roomList;
      const totalChildren = roomList
        .map((room) => room.children.childrenList.length)
        .reduce((a, b) => a + b);
      return totalChildren;
    },

    totalNights(state) {
      const checkIn = state.bookingData.checkIn;
      const checkOut = state.bookingData.checkOut;
      return -moment(new Date(checkIn)).diff(
        moment(new Date(checkOut)),
        "days"
      );
    },

    isKidTiersSupport(state) {
      return state.isTiersSupport;
    },

    isBedOptionDisabled(state) {
      return state.disableBedOption;
    },

    totalGuest(state, getters) {
      return getters.numberAdults + getters.numberChildren;
    },

    getCheckinDate: (state) => {
      let format = "MMM DD";
      let lang = state.lang;
      switch (state.lang) {
        case "ja":
          format = "MMM DD日";
          break;
        case "ko":
          format = "MMM DD일";
          break;
        case "zh-Hant":
          format = "MMM DD年";
          lang = "zh-CN";
          break;
        case "zh-Hans":
          format = "MMM DD年";
          lang = "zh-TW";
          break;
        case "zh_Hant":
          format = "MMM DD年";
          lang = "zh-CN";
          break;
        case "zh_Hans":
          format = "MMM DD年";
          lang = "zh-TW";
          break;
      }
      return moment(new Date(state.bookingData.checkIn))
        .locale(lang)
        .format(format)
        .toString();
    },

    getCheckoutDate: (state) => {
      let format = "MMM DD";
      let lang = state.lang;
      switch (state.lang) {
        case "ja":
          format = "MMM DD日";
          break;
        case "ko":
          format = "MMM DD일";
          break;
        case "zh-Hant":
          format = "MMM DD年";
          lang = "zh-TW";
          break;
        case "zh-Hans":
          format = "MMM DD年";
          lang = "zh-CN";
          break;
        case "zh_Hant":
          format = "MMM DD年";
          lang = "zh-TW";
          break;
        case "zh_Hans":
          format = "MMM DD年";
          lang = "zh-CN";
          break;
      }
      return moment(new Date(state.bookingData.checkOut))
        .locale(lang)
        .format(format)
        .toString();
    },

    isMobile(state) {
      return state.isMobile;
    },

    roomList(state) {
      return state.roomList;
    },

    roomLeft(state) {
      const checkIn = moment(new Date(state.bookingData.checkIn)).format(
        "YYYY/MM/DD"
      );
      const { inventory } = state;
      return inventory[checkIn] ? +inventory[checkIn] : "NaN";
    },

    currentRoomActive(state) {
      const roomIndex = state.currentRoomActive;
      return {
        ...state.roomList[roomIndex],
      };
    },

    roomListStatus(state) {
      const { inventoryList } = state;
      const checkIn = moment(new Date(state.bookingData.checkIn)).format(
        "YYYY/MM/DD"
      );

      if (!Array.isArray(inventoryList)) return [];

      return (
        inventoryList &&
        inventoryList.map((item) => {
          return item.inventory[checkIn] ? false : true;
        })
      );
    },

    isRoomValid(state, getters) {
      return !getters["roomListStatus"][state.currentRoomActive];
    },
  },
});
